import config from '@config'
import { JSONWidgetType as TeaserBiteJSONWidgetType } from '@widgets/TeaserBite'

import {
  ExecuteQuery,
  getAureusBatchRecommendations,
  getSectionWithAureusEnvironment,
  Purpose,
  QueryFactory,
} from '..'

interface BlickBiteItem extends Record<string, unknown> {
  aureusOfferId: string
  articleID: string
  teasers: {
    bite: TeaserBiteJSONWidgetType
  }
}

const {
  publication: { publication },
} = config

export const queryKey = 'polaris-bites'

export const createQuery = (({
  purpose = 'reference',
  contentBlacklist,
  pinningOffset,
  deboosted = [],
}: {
  purpose?: Purpose
  contentBlacklist?: string
  pinningOffset?: number
  deboosted?: string[]
}) =>
  ({
    [queryKey]: {
      resultsLimit: 5,
      pinningOffset,
      context: {
        section: getSectionWithAureusEnvironment(
          `polaris-${publication === 'romandie' ? 'romandie-' : ''}bites`,
        ),
        purpose,
        contentBlacklist,
        currentSession: {
          deboosted,
        },
      },
    },
  }) as const) satisfies QueryFactory<typeof queryKey>

export const executeQuery = (async (
  queryOptions: Parameters<typeof createQuery>[0],
  options?: Record<string, unknown>,
) => {
  try {
    const result = (
      await getAureusBatchRecommendations<typeof queryKey, BlickBiteItem>(
        createQuery(queryOptions),
        options,
      )
    ).results[queryKey]

    if (!Array.isArray(result?.recommendations)) {
      return
    }

    return result.recommendations
  } catch (err) {
    console.error(err)
  }
}) satisfies ExecuteQuery<typeof queryKey>
